import { useId } from "react";
import { createUseStyles } from "react-jss";
import ReferenceStroke from "../models/ReferenceStroke";

interface Props {
  stroke: ReferenceStroke;
  index: number;
  strokeSpeed: number;
}

export default function StrokeDisplay(props: Props) {
  const { stroke } = props;

  const id = useId();
  const classes = useStyles(props);

  return (
    <g>
      <clipPath id={`${id}-clip-path`}>
        <path d={stroke.fill.path} />
      </clipPath>
      <path
        d={stroke.trace.path}
        strokeWidth={stroke.trace.strokeWidth}
        pathLength={1000}
        className={classes.trace}
        clipPath={`url(#${id}-clip-path)`}
      />
    </g>
  );
}

const STROKE_TRACE_INTERVAL_SECS = 0.15;

const useStyles = createUseStyles({
  "@keyframes trace": {
    to: {
      strokeDashoffset: 0,
    },
  },
  "trace": {
    fill: "none",
    stroke: "black",
    strokeDasharray: 1000,
    strokeDashoffset: 1000,
    animation: ({ index, strokeSpeed }: Props) =>
      `$trace ${strokeSpeed}s linear forwards ${
        index * (strokeSpeed + STROKE_TRACE_INTERVAL_SECS)
      }s`,
  },
});
